import product from './product/index'
const arr = [{ //首页
    path: 'index',
    component: resolve => {
      require(['../../views/inner/index.vue'], resolve)
    },
    redirect: '/fr/app/inner/index/myService',
    children: [{
        path: 'myService', //我的服务
        component: resolve => {
          require(['../../views/inner/forInner/myService.vue'], resolve)
        },
        meta: {
          keepAlive: true
        }
      },
      {
        path: 'insight', //机构洞察
        component: resolve => {
          require(['../../views/inner/forInner/insight.vue'], resolve)
        },
        meta: {
          keepAlive: true
        }
      },
      {
        path: 'personal', //私人定制
        component: resolve => {
          require(['../../views/inner/forInner/personal.vue'], resolve)
        },
        meta: {
          keepAlive: true
        }
      },
      {
        path: 'secretary', //解忧秘书
        component: resolve => {
          require(['../../views/inner/forInner/secretary.vue'], resolve)
        },
        meta: {
          keepAlive: true
        }
      },
    ]
  },
  { //王牌产品模块列表详情
    path: 'product',
    component: resolve => {
      require(['../../views/inner/product/base.vue'], resolve)
    },
    children: product
  },
  {
    path: 'textLive', //文字直播
    component: resolve => {
      require(['../../views/inner/textLive/index.vue'], resolve)
    }
  },
  {
    path: 'niuniu', //牛牛直播
    component: resolve => {
      require(['../../views/inner/textLive/niuniu.vue'], resolve)
    }
  },
  {
    path: 'zxStock', //自选股
    component: resolve => {
      require(['../../views/inner/zixuangu/index.vue'], resolve)
    },
    meta: {
      keepAlive: true
    }
  },
  {
    path: 'zxSerach', //搜索自选股
    component: resolve => {
      require(['../../views/inner/zixuangu/serach.vue'], resolve)
    }
  },
  {
    path: 'zxStock_check', //管理自选股
    component: resolve => {
      require(['../../views/inner/zixuangu/splice.vue'], resolve)
    }
  },
  { //课程
    path: 'stockClass',
    component: resolve => {
      require(['../../views/inner/shareholdersCollege/base.vue'], resolve)
    },
    redirect: '/fr/app/inner/stockClass/home',
    children: [{
        path: 'home',
        component: resolve => {
          require(['../../views/inner/shareholdersCollege/home.vue'], resolve)
        }
      },
      {
        path: 'list',
        component: resolve => {
          require(['../../views/inner/shareholdersCollege/list.vue'], resolve)
        }
      },
      {
        path: 'video_details',
        component: resolve => {
          require(['../../views/inner/shareholdersCollege/video_details.vue'], resolve)
        }
      },
      {
        path: 'buy',
        component: resolve => {
          require(['../../views/inner/shareholdersCollege/buy.vue'], resolve)
        }
      },
      {
        path: 'success',
        component: resolve => {
          require(['../../views/inner/shareholdersCollege/success.vue'], resolve)
        }
      },
      {
        path: 'more',
        component: resolve => {
          require(['../../views/inner/shareholdersCollege/more.vue'], resolve)
        }
      },
      {
        path: 'more1',
        component: resolve => {
          require(['../../views/inner/shareholdersCollege/more1.vue'], resolve)
        }
      }
    ]
  }
]
export default arr



// WEBPACK FOOTER //
// ./src/router/inner/inner.js